import React, { useEffect } from 'react';

function useResizeObserver(
    targetRef: React.RefObject<Element>,
    onSizeChange: (size: number) => void,
    observeIf = true,
) {
    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries = []) => {
            const { contentRect = {} as ResizeObserverEntry['contentRect'] } = entries[0];
            const { height = 0, top = 0 } = contentRect;
            const size = height + top * 2;
            onSizeChange(size);
        });

        if (targetRef?.current && observeIf) {
            resizeObserver.observe(targetRef.current);
        }

        return () => {
            resizeObserver.disconnect();
            onSizeChange(0);
        };
    }, [targetRef, onSizeChange, observeIf]);
}

export default useResizeObserver;
